export default[
    {
      movieImage: './popular-images/wall.jpg',
      movieName: 'WALL-E',
      
      yearOfRelease: 2008,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/danger.jpg',
      movieName: 'A Dangerous Method',
       
      yearOfRelease: 2011,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Tangled.jpg',
      movieName: 'Tangled',
       
      yearOfRelease: 2010,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Marilyn.jpg',
      movieName: 'My Week with Marilyn',
     
      yearOfRelease: 2011,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Paris.jpg',
      movieName: 'Midnight in Paris',
       
      yearOfRelease: 2011,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Universe.jpg',
      movieName: 'Across the Universe',
      
      yearOfRelease: 2007,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Knocked.jpg',
      movieName: 'Knocked Up',
    
      yearOfRelease: 2007,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Twilight.jpg',
      movieName: 'Twilight',
      
      yearOfRelease: 2008,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/love.jpg',
      movieName: 'P.S. I Love You',
      
      yearOfRelease: 2007,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Universe.jpg',
      movieName: 'Across the Universe',
      
      yearOfRelease: 2007,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Knocked.jpg',
      movieName: 'Knocked Up',
    
      yearOfRelease: 2007,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Twilight.jpg',
      movieName: 'Twilight',
      
      yearOfRelease: 2008,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/love.jpg',
      movieName: 'P.S. I Love You',
      
      yearOfRelease: 2007,
      duration: "121 min"
    },
    {
      movieImage: './popular-images/Universe.jpg',
      movieName: 'Across the Universe',
      
      yearOfRelease: 2007,
      duration: "121 min"
    }
  
  ]
  